import { Component, OnInit } from '@angular/core';
import { NewPageList } from '../../core/models/new-page-list';
import { NewPageService } from '../../templates/new-page/service/new-page.service'
import { firebase } from '@firebase/app';
import { ContentsMandatory } from '../../core/models/contents-mandatory';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';
import { NewPagePref } from '../../core/models/new-page-prefs';
import { Constants } from '../../core/config/Constants';
@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.css']
})
export class ImageComponent implements OnInit {

  aboutUs: NewPageList;

  eventId: string;
  message: string;
  cmCategory: string;
  uploadFileName: string = null;
  uploadprogress: number = null;

  eventImage: boolean = true;
  constructor(private newPageService: NewPageService, private confirmationService: ConfirmationService) {
  }

  ngOnInit() {
    this.aboutUs.aboutPrefs = new NewPagePref();
    if (this.aboutUs.contentMandatoryList[0]) {
      this.newPageService.getContentsMandatory(this.aboutUs.contentMandatoryList[0], this.eventId).subscribe((conMan) => {
        this.newPageService.getFile(conMan, this.eventId).then((url) => {
          this.src = url;
        });
      });
    }
  }

  src = 'assets/img/sharry.jpg';
  _ref: any;

  onBasicUpload(event) {
    if (event.files[0]) {
      this.newPageService.uploadFile(this.eventId, event.files[0], this.cmCategory).on(firebase.storage.TaskEvent.STATE_CHANGED,
        (snapshot) => {
          this.uploadFileName = event.files[0].filename;
          this.uploadprogress = Math.floor((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
        },
        (error) => {
        },
        () => {
          let contentsMandatory = new ContentsMandatory();
          if (this.cmCategory) {
            contentsMandatory.category = this.cmCategory;
          } else {
            contentsMandatory.category = Constants.CONTENT_M_TYPE_ABOUT;
          }

          contentsMandatory.eventId = this.eventId;
          contentsMandatory.filename = event.files[0].name;
          contentsMandatory.sizeInBytes = event.files[0].size;
          contentsMandatory.extension = event.files[0].type.split('/').pop();
          console.log(contentsMandatory);
          let key = this.newPageService.addContentMandatory(contentsMandatory);
          if (key) {
            this.aboutUs.contentMandatoryList = new Array();
            this.aboutUs.contentMandatoryList.push(key);
            this.message = "File Uploaded Successfully";
            console.log(this.message)
          }
          this.newPageService.getFile(contentsMandatory, this.eventId).then((url) => {
            this.src = url;
          });
        }
      );
    }
  }
  deleteImage() {
    this.aboutUs.contentMandatoryList = new Array();
    this.uploadFileName = null;
    this.uploadprogress = null;
  }

  confirmDelete() {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete ?',
      accept: () => {
        this.remove();
      }
    });
  }

  remove() {
    this._ref.destroy();
    this.newPageService.removeItem(this.aboutUs);
  }

  upItem() {
    this.newPageService.upItem(this.aboutUs);
  }

  downItem() {
    this.newPageService.downItem(this.aboutUs);
  }
}



// WEBPACK FOOTER //
// /app/src/app/layout/image/image.component.ts